import * as React from 'react'

import { defaultSize, Sizes } from './Button.sizes'
import { Icon, IconType, SizeType, StyledButton, StyledButtonProps } from './Button.style'
import { defaultTheme, ButtonThemes } from './Button.themes'

interface ButtonProps extends StyledButtonProps {
    children?: React.ReactNode
    className?: string
    disabled?: boolean
    fullWidth?: boolean
    icon?: IconType
    iconOnly?: boolean
    iconSize?: SizeType
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => any
    radius?: number | string
    size?: Sizes
    theme?: ButtonThemes
    style?: Record<string, string | number>
    title?: string
    width?: string
}

function Button(props: ButtonProps): React.ReactElement {
    const {
        children,
        icon,
        iconOnly,
        iconSize = 'lg',
        onClick = () => undefined,
        radius = 5,
        size = defaultSize,
        theme = defaultTheme,
        ...rest
    } = props

    return (
        <StyledButton onClick={onClick} radius={radius} size={size} theme={theme} type="button" {...rest}>
            {icon && <Icon icon={icon} iconOnly={iconOnly} size={iconSize} />}
            {children}
        </StyledButton>
    )
}

export default Button
